export default "__VITE_ASSET__B8rCq1Rr__"